
import { defineComponent } from "vue";

export default defineComponent({
  name: "SideBar",
  setup() {
    return {};
  },
});
